import PropTypes from 'prop-types';

export default PropTypes.shape({
    x: PropTypes.number.isRequired,
    y: PropTypes.number.isRequired
});


//////////////////
// WEBPACK FOOTER
// ./node_modules/react-image-magnify/dist/es/prop-types/Point.js
// module id = 114
// module chunks = 0